import { render, staticRenderFns } from "./colorPicker.vue?vue&type=template&id=34e72e72&scoped=true"
import script from "./colorPicker.vue?vue&type=script&lang=js"
export * from "./colorPicker.vue?vue&type=script&lang=js"
import style0 from "./colorPicker.vue?vue&type=style&index=0&id=34e72e72&prod&lang=less&scoped=true"
import style1 from "./colorPicker.vue?vue&type=style&index=1&id=34e72e72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e72e72",
  null
  
)

export default component.exports